import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list';
import {
    getAccountByMailboxInfo,
    getSelectedAccountMailboxInfo,
} from 'owa-account-source-list-store';
import { isConnectedAccount } from 'owa-accounts-store';
import type { MailboxInfo } from 'owa-client-types';
import type CategoryType from 'owa-service/lib/contract/CategoryType';
import {
    getAccountScopeUserSettings,
    getConnectedAccountUserConfiguration,
} from 'owa-session-store';

/**
 * Gets the MasterCategoryList for the given mailboxInfo. This will be different from the
 * default MasterCategoryList for a connected account since the userConfiguration is different.
 * @param mailboxInfo The mailbox to fetch the user configuration for
 */
export default function getMasterCategoryList(mailboxInfo: MailboxInfo): CategoryType[] {
    let userConfiguration;

    if (!isMonarchMultipleAccountsEnabled() && isConnectedAccount(mailboxInfo.userIdentity)) {
        userConfiguration = getConnectedAccountUserConfiguration(mailboxInfo.userIdentity);
    } else {
        if (!mailboxInfo.sourceId) {
            const mailboxInfoWithSourceId =
                getAccountByMailboxInfo(mailboxInfo)?.mailboxInfo ??
                getSelectedAccountMailboxInfo();
            userConfiguration = getAccountScopeUserSettings(mailboxInfoWithSourceId);
        } else {
            userConfiguration = getAccountScopeUserSettings(mailboxInfo);
        }
    }

    let masterCategoryList = userConfiguration?.MasterCategoryList;

    // the MasterCategoryList can be null for shared mailboxes
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS4104 (27,5): The type 'readonly RecursiveReadOnly<CategoryType>[]' is 'readonly' and cannot be assigned to the mutable type 'CategoryType[]'.
    // @ts-expect-error
    return masterCategoryList?.MasterList || [];
}
